import React, { useEffect } from 'react'
import Helmet from 'react-helmet'
import { GatsbyImage } from "gatsby-plugin-image";

import { Layout } from '../components/common'
import { MetaData } from '../components/common/meta'
import SocialIcons from '../components/common/SocialIcons'
import ContactForm from '../components/sections/contact-form'

const PageDefault = ({ data, location }) => {
	const page = data.ghostPage
    let pageImageAspectRatio = null;
    if (
            page.localFeatureImage
            && page.localFeatureImage.childImageSharp
            && page.localFeatureImage.childImageSharp.gatsbyImageData
        ) {
        let _image = page.localFeatureImage.childImageSharp.gatsbyImageData;
        pageImageAspectRatio = _image.width / _image.height;
    }
	const hasImage = page.feature_image ? 'has-image' : 'orphan'
	let pageImageShape

    if ( pageImageAspectRatio < 1 ) {
        pageImageShape = 'portrait'
    } else if (pageImageAspectRatio == 1) {
        pageImageShape = 'square'
    } else {
        pageImageShape = 'landscape'
    }

	useEffect(() => {
		page.codeinjection_head && document.head.append(document.createRange().createContextualFragment(page.codeinjection_head))
        page.codeinjection_foot && document.body.append(document.createRange().createContextualFragment(page.codeinjection_foot))
	}, [])

	return <>
        <MetaData
            data={data}
            location={location}
            type="website"
        />
        <Helmet>
            <style type="text/css">{`${page.codeinjection_styles}`}</style>
        </Helmet>
        <Layout>
            <article>
                <div className="container">
                    <header className="post__header">
                        <SocialIcons type={'light'} position={'absolute'} />
                        <div className={`post__title ${hasImage}`}>
                            <h1>{page.title}</h1>
                        </div>
                        {page.feature_image ?
                            <figure className={`post__feature-image ${pageImageShape}`}>
                                <GatsbyImage
                                    image={page.localFeatureImage && page.localFeatureImage.childImageSharp && page.localFeatureImage.childImageSharp.gatsbyImageData}
                                    loading="auto"
                                    alt={page.title} />
                            </figure> : null}
                    </header>
                </div>
                <div className="post__full-content">
                    <div className="container">
                        <div className="content">
                            <section
                                className="content-body load-external-scripts"
                                dangerouslySetInnerHTML={{ __html: page.html }}
                            />
                        </div>
                    </div>
                </div>
            </article>
            <ContactForm />
        </Layout>
    </>;
}

export default PageDefault